import React, { useState } from "react";
import classes from "./FAQ.module.css";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const FAQ = ({ faqs }) => {
  // let push = useNavigate();
  let navigate = useNavigate();

  let { category } = useParams();

  const [categories, setCategories] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null); //Can be used to show the selected category in UI element
  const [subCategories, setSubCategories] = useState(null);

  //If we get the category from the paramas
  if (category && !selectedCategory) {
    setSelectedCategory(category);
  }
  //Runs when user selects a category
  const _onCategoryClick = (category) => {
    const _subCategories = [];
    faqs.forEach((faq) => {
      if (faq.category === category) {
        _subCategories.push(faq.sub_category);
      }
    });
    
    setSubCategories(Array.from(new Set(_subCategories)));
    setSelectedCategory(categories);
    // push(`/${category}`);
    navigate(`/${category}/${_subCategories[0]}`);
  };

  //Runs when user selects a sub category
  const _onSubCategoryClick = (subCategory) => {
    navigate(`/${category}/${subCategory}`);
  };

  //Runs when faqs get loaded from Fetch in App.js
  if (faqs.length > 0) {
    if (!categories) {
      let _categories = new Set(faqs.map((faq) => faq.category));
      setCategories(Array.from(_categories));
    }
    if (category && !subCategories) {
      // Runs if we get category from URL
      const _subCategories = [];
      faqs.forEach((faq) => {
        if (faq.category === category) {
          _subCategories.push(faq.sub_category);
        }
      });
      setSubCategories(Array.from(new Set(_subCategories)));
    }
  }

  let nullElement = null;
  //Tried to display the normal categories available if the one from URL doesnt exsists, that didnt worked (obviously you can try to fix it). for the time being theres a place holder that displays the message that there is no such category

  if (categories && selectedCategory) {
    if (!categories.includes(selectedCategory)) {
      nullElement = <h1>No Such category found</h1>;
    }
  }
  if (subCategories && subCategories.length > 0) {
    nullElement = null;
  }

  return (
    <div
      className="container justify-content-center align-items-center"
      style={{ flexDirection: "column" }}
    >
      <h2 className="text-center">अपने सभी सवालों के उत्तर नीचे दिए गए FAQ सेक्शन में पाएं:</h2>
      {/* <h6 className="text-center text-muted mt-3 font-weight-bold">
      
      </h6> */}
      <hr className="mt-3 boost-hr" />

      <div className={classes.btnContainer} >
        {categories && !selectedCategory
          ? categories.map((category) => {
            let c = category
            if(c===category){
              let categoryDisplay = category.replaceAll('_', ' ')
              // console.log(c)
              return(
                <button
                  key={category}
                  onClick={() => _onCategoryClick(category)}
                  className={`${classes.btn} ${classes.active}`}
                >
                  {categoryDisplay}
                </button>
              ) 
            }else{
              let categoryDisplay = category.replaceAll('_', ' ')
            // console.log(c)
            return(
              <button
                key={category}
                onClick={() => _onCategoryClick(category)}
                className={classes.btn}
              >
                {categoryDisplay}
              </button>
            )
            }
            })
          : subCategories
          ? subCategories.map((subCategory) => {
            let subCategoryDisplay = subCategory.replaceAll('_', ' ');
            return(
              <button
                key={subCategory}
                onClick={() => _onSubCategoryClick(subCategory)}
                className={classes.btn}
              >
                {subCategoryDisplay}
              </button>
            )})
          : null}
        {nullElement ? nullElement : null}
      </div>

    </div>
  );
};

export default FAQ;
